<template>
  <div>

    <v-snackbar v-model="mensaje.snackbar" :timeout="mensaje.timeout" :color="mensaje.color" text top right>
      {{ mensaje.text }}
      <template v-slot:action="{ attrs }">
        <v-btn :color="mensaje.colorBtn" text v-bind="attrs" @click="mensaje.snackbar = false">Close</v-btn>
      </template>
    </v-snackbar>

    <v-card>
      <v-toolbar flat color="primary" dark>
        <v-toolbar-title>Mis Pedidos</v-toolbar-title>
      </v-toolbar>

      <v-card-text v-if="pedidos.length === 0" class="text-center py-10">
        <v-icon size="80" color="grey lighten-1">mdi-clipboard-text-off</v-icon>
        <p class="mt-4 grey--text" style="font-size: 16px;">No tienes pedidos aún</p>
        <v-btn outlined color="primary" @click="$router.push('/store/all')">
          <v-icon left>mdi-store</v-icon>
          Ir a la tienda
        </v-btn>
      </v-card-text>

      <v-card-text v-else>

        <v-simple-table fixed-header>
          <template v-slot:default>
            <thead class="thead-dark">
              <tr>
                <th>N° Pedido</th>
                <th>Estado</th>
                <th>Monto Total</th>
                <th>Fecha</th>
                <th>Ver Detalle</th>
                <th>Acción</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="pedido in pedidos" :key="pedido.id">
                <td>{{ pedido.comprobante_numero }}</td>
                <td>
                  <v-chip
                    small
                    :color="colorEstado(pedido.estado)"
                    dark
                  >
                    <v-icon left small>{{ iconoEstado(pedido.estado) }}</v-icon>
                    {{ textoEstado(pedido.estado) }}
                  </v-chip>
                </td>
                <td>Gs. {{ formatearPrecio(pedido.monto_total) }}</td>
                <td>{{ pedido.fecha_registro }}</td>
                <td>
                  <v-btn small color="primary" outlined @click="toggleDetalle(pedido.id)">
                    <v-icon left small>{{ detalleAbierto === pedido.id ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    {{ detalleAbierto === pedido.id ? 'Ocultar' : 'Ver' }}
                  </v-btn>
                </td>
                <td>
                  <v-btn
                    v-if="pedido.estado === 'pedido-en-transito'"
                    small
                    color="teal"
                    dark
                    @click="marcarRecibido(pedido)"
                  >
                    <v-icon left small>mdi-package-check</v-icon>
                    Recibido
                  </v-btn>
                  <v-btn
                    v-else-if="pedido.estado === 'confirmado'"
                    small
                    color="red"
                    dark
                    @click="cancelarPedido(pedido)"
                  >
                    <v-icon left small>mdi-close-circle</v-icon>
                    Cancelar
                  </v-btn>
                  <span v-else class="grey--text text--lighten-1" style="font-size: 12px;">—</span>
                </td>
              </tr>

              <!-- DETALLE EXPANDIBLE -->
              <tr v-for="pedido in pedidos" :key="'det-' + pedido.id" v-show="detalleAbierto === pedido.id">
                <td colspan="6" class="pa-3" style="background: #f5f5f5;">
                  <strong class="mb-2 d-block">Detalle del Pedido #{{ pedido.comprobante_numero }}</strong>
                  <v-simple-table dense>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th>Imagen</th>
                          <th>Producto</th>
                          <th>Cantidad</th>
                          <th>Precio</th>
                          <th>Subtotal</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="det in pedido.detalle_pedidos" :key="det.id">
                          <td>
                            <v-img
                              v-if="det.producto"
                              :src="serverUrl + 'api/productos/get_img_unico_producto/' + det.producto.id + '/' + det.producto.link_photo"
                              width="45"
                              height="45"
                              contain
                              style="border-radius: 4px;"
                            ></v-img>
                          </td>
                          <td>{{ det.producto ? det.producto.descripcion : '—' }}</td>
                          <td>{{ det.cantidad }}</td>
                          <td>Gs. {{ formatearPrecio(det.precio_pedido) }}</td>
                          <td>Gs. {{ formatearPrecio(det.precio_pedido_total) }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </td>
              </tr>

            </tbody>
          </template>
        </v-simple-table>

      </v-card-text>
    </v-card>

  </div>
</template>

<script>
import misPedidosService from '@/services/misPedidosService';
import { http } from '@/services/config';

export default {
  name: 'MisPedidos',

  data() {
    return {
      serverUrl: http.defaults.baseURL,
      pedidos: [],
      detalleAbierto: null,
      mensaje: { snackbar: false, text: '', color: '', timeout: 5000, colorBtn: 'white' }
    };
  },

  mounted() {
    this.listarMisPedidos();
  },

  methods: {
    formatearPrecio(valor) {
      if (!valor) return '0';
      return Math.floor(valor).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },

    colorEstado(estado) {
      const colores = {
        'confirmado': '#1a73e8',
        'cancelado': '#F44336',
        'pagado': '#43A047',
        'pedido-en-preparacion': '#FF9800',
        'pedido-en-transito': '#7B1FA2',
        'pedido-recibido': '#00897B'
      };
      return colores[estado] || 'grey';
    },

    iconoEstado(estado) {
      const iconos = {
        'confirmado': 'mdi-check',
        'cancelado': 'mdi-close-circle',
        'pagado': 'mdi-currency-usd',
        'pedido-en-preparacion': 'mdi-package-variant',
        'pedido-en-transito': 'mdi-truck-delivery',
        'pedido-recibido': 'mdi-package-check'
      };
      return iconos[estado] || 'mdi-help-circle';
    },

    textoEstado(estado) {
      const textos = {
        'confirmado': 'Confirmado',
        'cancelado': 'Cancelado',
        'pagado': 'Pagado',
        'pedido-en-preparacion': 'En preparación',
        'pedido-en-transito': 'En tránsito',
        'pedido-recibido': 'Recibido'
      };
      return textos[estado] || estado;
    },

    toggleDetalle(pedidoId) {
      this.detalleAbierto = this.detalleAbierto === pedidoId ? null : pedidoId;
    },

    listarMisPedidos() {
      misPedidosService.listarMisPedidos()
        .then(res => { this.pedidos = res.data.data; })
        .catch(() => { this.mensajeError('Error al cargar los pedidos'); });
    },

    async marcarRecibido(pedido) {
      if (!confirm('¿Confirma que recibió el pedido N° ' + pedido.comprobante_numero + '?')) return;
      try {
        await misPedidosService.marcarRecibido(pedido.id);
        this.mensajeOk('Pedido marcado como recibido');
        this.listarMisPedidos();
      } catch (error) {
        this.mensajeError('Error al actualizar el estado');
      }
    },

    async cancelarPedido(pedido) {
      if (!confirm('¿Desea cancelar el pedido N° ' + pedido.comprobante_numero + '? Esta acción no se puede deshacer.')) return;
      try {
        await misPedidosService.cancelarPedido(pedido.id);
        this.mensajeOk('Pedido cancelado correctamente');
        this.listarMisPedidos();
      } catch (error) {
        const msg = error.response?.data?.message || 'Error al cancelar el pedido';
        this.mensajeError(msg);
      }
    },

    mensajeOk(texto) {
      this.mensaje = { snackbar: true, text: texto, color: 'success', timeout: 5000, colorBtn: 'white' };
    },

    mensajeError(texto) {
      this.mensaje = { snackbar: true, text: texto, color: 'error', timeout: 5000, colorBtn: 'white' };
    }
  }
};
</script>
